import { motion } from "framer-motion";
import { MANIFESTO } from "@/data/content";

const reveal = {
  hidden: { opacity: 0, y: 40 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, delay: i * 0.15, ease: [0.16, 1, 0.3, 1] },
  }),
};

export const Manifesto = () => {
  return (
    <section
      id="metodo"
      data-testid="manifesto-section"
      className="max-w-[1400px] mx-auto px-5 sm:px-8 py-24 md:py-40"
    >
      <div className="grid lg:grid-cols-12 gap-10 lg:gap-16">
        <div className="lg:col-span-4">
          <p className="text-xs font-bold tracking-[0.25em] uppercase text-green mb-5">
            Nuestro método
          </p>
          <h2 className="font-display font-black text-4xl md:text-5xl lg:text-6xl tracking-tighter leading-[0.95]">
            Menos ruido.<br />
            <span className="whitespace-nowrap">
              Más <span className="italic font-clash">estrategia</span>.
            </span>
          </h2>
          <p className="mt-6 text-ink/60 text-base max-w-sm">
            Un proceso claro en tres pasos para llevar tu marca de la idea a los
            resultados reales.
          </p>
        </div>

        <div className="lg:col-span-8 flex flex-col">
          {MANIFESTO.map((m, i) => (
            <motion.div
              key={m.n}
              custom={i}
              variants={reveal}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-80px" }}
              data-testid={`manifesto-item-${m.n}`}
              className="group grid grid-cols-[auto,1fr] gap-6 md:gap-12 py-8 md:py-10 border-t border-ink/10 last:border-b"
            >
              <span className="font-display font-black text-5xl md:text-7xl text-mango transition-colors duration-500 tracking-tighter">
                {m.n}
              </span>
              <div className="pt-1 md:pt-3">
                <h3 className="font-display font-bold text-2xl md:text-4xl tracking-tight mb-3">
                  {m.title}
                </h3>
                <p className="text-ink/65 text-base md:text-lg max-w-xl leading-relaxed">
                  {m.text}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
